export default function Footer() {
  return (
    <footer
      style={{
        position: "relative",
        zIndex: 1,
        borderTop: "1px solid var(--line)",
        padding: "24px 40px",
        background: "var(--bg)",
        color: "var(--ink-dim)",
        fontSize: 11,
        fontFamily: '"DM Sans", sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: 1440,
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <span>© 2026 SOYPACOIA — LATAM</span>
        <a
          href="mailto:soypacoia@gmail.com"
          style={{ color: "var(--ink-dim)" }}
        >
          soypacoia@gmail.com
        </a>
        <span style={{ display: "inline-flex", flexWrap: "wrap", gap: "6px 16px" }}>
          <a href="/privacidad" style={{ color: "var(--ink-dim)" }}>
            Aviso de privacidad
          </a>
          <a href="/terminos" style={{ color: "var(--ink-dim)" }}>
            Términos
          </a>
        </span>
        <a
          href="https://soypacoia.com"
          target="_blank"
          rel="noreferrer"
          style={{ color: "var(--ink-dim)" }}
        >
          soypacoia.com
        </a>
      </div>
    </footer>
  );
}
